<template>
  <div :class="[side % 2 ? 'left-side' : 'right-side']">
    <div class="column">
      <label>Saison</label>
      {{ history.season }}
    </div>
    <div class="column">
      <label>Verein</label>
      {{ history.team }}
    </div>
    <div class="column">
      <label>Altersklasse</label>
      {{ history.class }}
    </div>
    <div class="column">
      <label>Position</label>
      {{ history.position }}
    </div>
    <div class="column">
      <label>Liga</label>
      {{ history.league }}
    </div>

    <div v-if="showMore === true">
      <div class="column">
        <label>Spiele</label>
        {{ history.games_player }}
      </div>
      <div class="column">
        <label>Tore</label>
        {{ history.goals }}
      </div>
      <div class="column">
        <label>Assists</label>
        {{ history.assists }}
      </div>
      <div @click="showMore = false" class="more">Weniger anzeigen</div>
    </div>
    <div @click="showMore = true" class="more" v-else>Mehr anzeigen</div>
  </div>
</template>

<script>
export default {
  props: ['history', 'side'],
  data: () => ({
    showMore: false,
  }),
};
</script>
